import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRefresh, faTimes } from '@fortawesome/free-solid-svg-icons';
import '../../styles/common/SnackbarNotification.css';

/**
 * SnackbarNotification - A bottom notification banner with refresh action
 * Shows when content changes require a page refresh
 */
const SnackbarNotification = ({ isVisible, onRefresh, onDismiss, message }) => {
  // Default message
  const defaultMessage = "New changes were made...refresh";
  
  if (!isVisible) return null;

  const handleRefresh = () => {
    window.location.reload();
    if (onRefresh) onRefresh();
  };

  const handleDismiss = () => {
    if (onDismiss) onDismiss();
  };

  return (
    <div className="snackbar-notification">
      <div className="snackbar-content">
        <div className="snackbar-message">
          <span>{message || defaultMessage}</span>
        </div>
        
        <div className="snackbar-actions">
          <button 
            className="snackbar-refresh-btn"
            onClick={handleRefresh}
            title="Refresh page to see changes"
          >
            <FontAwesomeIcon icon={faRefresh} />
            Refresh
          </button>
          
          <button 
            className="snackbar-dismiss-btn"
            onClick={handleDismiss}
            title="Dismiss notification"
          >
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default SnackbarNotification;